/**
 * Gives every auth entry path a recovery action when browser session storage
 * cannot be restored. Magic-link callbacks encounter the same failure as
 * protected application routes, so this remains a shared component.
 */
export function AuthInitializationRecovery() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <p className="text-sm font-medium text-foreground">Unable to restore your session</p>
        <p className="mt-2 text-sm text-muted-foreground">
          Please reload Relay. If this continues, clear this site&apos;s stored data and sign in again.
        </p>
        <button
          type="button"
          className="mt-4 rounded-md bg-foreground px-3 py-2 text-sm font-medium text-background hover:bg-foreground/90"
          onClick={() => window.location.reload()}
        >
          Reload Relay
        </button>
      </div>
    </div>
  );
}
